import {
	IAcaoEmLoteDTO,
	IBigNumbersResponseDTO,
	IDespesaCleanDTO,
	IDespesaDTO,
	IDespesaEdicaoEmLoteDTO,
	IDespesaFullDTO,
	IDespesaPagamentoDTO,
	ITimeLineHistoricoDespesaDTO,
} from '../models/happy-code-api.model';
import { baseCreate } from './base/base-create.service';
import { baseDelete } from './base/base-delete.service';
import { baseFindById } from './base/base-find-id.service';
import { baseFind } from './base/base-find.service';
import http from '../helpers/http-common';
import { AxiosResponse } from 'axios';
import { formatHttpParams, Predicate } from '../models/predicate.model';
import { baseFindList } from './base/base-find-list.service';
import { baseUpdate } from './base/base-update.service';
import { PageableResponse } from '../models/response.model';

export const useDespesaService = () => {
	const resourceURL = '/despesa';

	const getBignumbers = (predicate: Predicate): Promise<AxiosResponse<IBigNumbersResponseDTO>> => {
		return http.get(`${resourceURL}/bignumbers`, formatHttpParams(predicate));
	};

	const findFullCustomTable = (predicate: Predicate): Promise<AxiosResponse<PageableResponse<IDespesaFullDTO>>> => {
		return http.get(`${resourceURL}/full-custom`, formatHttpParams(predicate));
	};

	const findFullCustomEdit = (id: number): Promise<AxiosResponse<IDespesaFullDTO>> => http.get(`${resourceURL}/get-despesa-edicao/${id}`);

	const acaoEmLote = (dto: Partial<IAcaoEmLoteDTO>): Promise<AxiosResponse> => http.post(`${resourceURL}/acao-em-lote`, dto);

	const deleteParcelasNaoVencidas = (id: number): Promise<AxiosResponse<void>> => {
		return http.delete(`${resourceURL}/${id}/nao-vencidas`);
	};

	const deleteParcelasEmAberto = (id: number): Promise<AxiosResponse<void>> => {
		return http.delete(`${resourceURL}/${id}/em-aberto`);
	};

	const excluirArquivoDaDespesa = (idDespesa: number, idArquivo: number): Promise<AxiosResponse<void>> => {
		return http.delete(`${resourceURL}/${idDespesa}/arquivo/${idArquivo}`);
	};
	
	const editarEmLote = (dto: IDespesaEdicaoEmLoteDTO): Promise<AxiosResponse<void>> =>
		http.patch(`${resourceURL}/editar-em-lote`, dto);

	const createCustom = (dto: IDespesaFullDTO): Promise<AxiosResponse<IDespesaFullDTO>> => http.post(resourceURL + `/create-custom`, dto);
	const patchCustom = (dto: IDespesaFullDTO): Promise<AxiosResponse<IDespesaFullDTO>> => http.patch(resourceURL + `/patch-custom`, dto);
	const createParcelamento = (dto: IDespesaFullDTO): Promise<AxiosResponse<IDespesaFullDTO>> => http.post(resourceURL + `/create-parcelamento`, dto);
	const createRepeticao = (dto: IDespesaFullDTO): Promise<AxiosResponse<IDespesaFullDTO>> => http.post(resourceURL + `/create-repeticao`, dto);
	const patchPaga = (dto: IDespesaPagamentoDTO): Promise<AxiosResponse> => http.patch(`${resourceURL}/pagar`, dto);
	const findHistory = (id: number): Promise<AxiosResponse<ITimeLineHistoricoDespesaDTO[]>> => http.get(`${resourceURL}/${id}/timeline-historico`);
	const findObservacaoHistory = (id: number): Promise<AxiosResponse<ITimeLineHistoricoDespesaDTO[]>> => http.get(`${resourceURL}/${id}/historico-observacao`);

	return {
		...baseCreate<IDespesaCleanDTO, IDespesaDTO, IDespesaFullDTO>(resourceURL),
		...baseFindById<IDespesaCleanDTO, IDespesaDTO, IDespesaFullDTO>(resourceURL),
		...baseFind<IDespesaCleanDTO, IDespesaDTO, IDespesaFullDTO>(resourceURL),
		...baseDelete(resourceURL),
		...baseFindList<IDespesaCleanDTO, IDespesaDTO, IDespesaFullDTO>(resourceURL),
		...baseUpdate<IDespesaCleanDTO, IDespesaDTO, IDespesaFullDTO>(resourceURL),
		getBignumbers,
		createCustom,
		patchCustom,
		createParcelamento,
		findFullCustomTable,
		patchPaga,
		findFullCustomEdit,
		acaoEmLote,
		deleteParcelasNaoVencidas,
		deleteParcelasEmAberto,
		createRepeticao,
		findHistory,
		findObservacaoHistory,
		excluirArquivoDaDespesa,
		editarEmLote
	};
};
